import React, {Component} from "react";
import {Link} from "react-router-dom";
import "./catagory.css";

import placeholder from './img/placeholder.png';

class CatagoryItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curPicture: placeholder
    };
  }
  getImageId = (url) =>{
    return url.substring(url.lastIndexOf('/')+1);
  }

  getResizeImage = (url, w, h) =>{
    const host = '//d3r3r4tgtn0hwd.cloudfront.net/'
    //return `${host}${w}x${h}/${this.getImageId(url)}`; disable size because resize function not working now
    return `${host}${this.getImageId(url)}`;
  }
  componentDidMount() {
    this.setState({
      curPicture: this.props.imageURL
    });
  }

  render() {
      return (
        <div className="catagoryItem col-md-3 col-sm-6 col-xs-12 category-alignment">
          <Link className="catagoryItemLink"  to={`/category/${this.props.cataName}`}>
            <div className="catagoryItemImgWrapper">
              <img
                src={this.getResizeImage(this.state.curPicture, '1200', '1800')}
                alt={this.props.cataName} className="category-image"/>
            </div>
             <span className="catagoryCaption">
                <span className="catagoryCaptionDec">{this.props.cataName}</span>
             </span>
          </Link>
        </div>
      );
  }

}

export default CatagoryItem;



// WEBPACK FOOTER //
// ./src/components/catagory/catagoryItem.js